class Source {
  constructor() {
    this.embeddable = false
    this.inputs = {
      MAIN: "TV",
      VOD: "TV",
      HLS: "TV",
      MULTICAST: "TV",
      RF: "TV",
      HDMI1: "HDMI1",
      HDMI2: "HDMI2",
      VGA: "VGA/PC",
      MIRACAST: "Wireless Display"
    }
    this.sources = []
  }

  async _init() {
    const sources = InputManager.getAVInputs()
    if (typeof sources.item === "function") {
      for (var i = 0; i < sources.length; i++) this.sources.push(sources.item(i))
    } else this.sources = Array.from(sources)

    InputManager.addEventListener("currentAVInputChangeEvent", this.sourceChanged)

    const current = await this.get().catch(err => _$.error(err))
    if (current !== this.inputs.MAIN) await this.set(this.inputs.MAIN).catch(err => _$.error(err))

    return true
  }

  async get() {
    return InputManager.getCurrentAVInput().name
  }
  async set(source_) {
    var target = null
    for (const source of this.sources) {
      if (source_ === source.name) target = source
    }

    if (!target) return false
    InputManager.stopCurrentSource()
    InputManager.selectSource(target)
    return true
  }
  async sourceChanged(event) {
    switch (event) {
      case InputManager.SourceChanged: //7
        _$.handler.emit("source_event", InputManager.getCurrentAVInput().name)
        break
      default:
        break
    }
  }
}

export default Source
